


















import { filterMixin } from '@/utils/mixins/filterMixin'
import { getAgencies } from '@/api/Agency/agency.api'
import Autocomplete from '@/components/Autocomplete.vue'
import { DeliveryCurrenciesEnum } from '~/utils/interfaces/remittance.interface'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    Autocomplete,
    FlatFilter,
  },
  props: {
    yours: Boolean,
  },
  data() {
    return {
      currencies: Object.values(DeliveryCurrenciesEnum),
      getAgencies: getAgencies,
    }
  },
})
